import React from 'react';
import { useNavigate } from 'react-router-dom';
import SignupForm from '../components/auth/SignupForm';
import Splash from '../components/Splash';
import ParticleBackground from '../components/ParticleBackground';

const SignupPage: React.FC = () => {
  const navigate = useNavigate();

  const handleSignupSuccess = () => {
    // Navigate to login page after successful signup
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row relative">
      {/* Particle Background */}
      <ParticleBackground />
      
      {/* Signup Form Side - White Container */}
      <SignupForm onSignupSuccess={handleSignupSuccess} />
    </div>
  );
};

export default SignupPage;